import { createContext, useContext, useMemo } from 'react';
export var algoliaClientContext = /*#__PURE__*/createContext(null);
export var AlgoliaClientProvider = algoliaClientContext.Provider;
export var useAlgoliaClient = function useAlgoliaClient() {
  var AlgoliaClient = useContext(algoliaClientContext);

  if (!AlgoliaClient) {
    throw new Error("Resources index isn't available. Please set it via AlgoliaClientProvider component.");
  }

  return AlgoliaClient;
};
export var useResourcesIndex = function useResourcesIndex() {
  var client = useAlgoliaClient();
  return useMemo(function () {
    return createResourcesIndex(client);
  }, [client]);
};
export var createResourcesIndex = function createResourcesIndex(client) {
  var _process$env$NEXT_PUB;

  var internalClient = client;
  return internalClient.initIndex((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_RESOURCES) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "");
};